module.exports = __webpack_public_path__ + "assets/img/assist-icon.15194088.png";